// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { indent16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-indent': IconIndent;
    }
}

/**
 * The icon component for the 'indent' icon
 */
export class IconIndent extends IconSvg {
    public constructor() {
        super(indent16X16);
    }
}

registerIconSvg('icon-indent', IconIndent);
export const iconIndentTag = 'nimble-icon-indent';
